import { ConnectedPosition } from '@angular/cdk/overlay';

export const OVERLAY_POSITIONS: ConnectedPosition[] = [
  {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
  },
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
  },
];

export const OVERLAY_POSITIONS_LEFT: ConnectedPosition[] = [
  {
    originX: 'start', // left edge of the origin
    originY: 'bottom', // bottom edge of the origin
    overlayX: 'start', // left edge of the overlay
    overlayY: 'top', // top edge of the overlay
    offsetX: -8,
  },
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
  },
];
